const theme = {
    // colors
    primary: '#ce2030',
    secondary: '#ffc836',
    red: '#ce2030',
    yellow: '#ffc836',
    
    // grayshades
    gray50: '#fafafa',
    gray100: '#f5f5f5',
    gray150: '#eff0f0',
    gray200: '#e9e9e9',
    gray225: '#e5e5e5',
    gray250: '#e4e5e6',
    gray300: '#e0e0e0',
    gray400: '#bdbdbd',
    gray500: '#9e9e9e',
    gray550: '#808080',
    gray600: '#757575',
    gray625: '#727377',
    gray650: '#686868',
    gray700: '#616161',
    gray750: '#58595d',
    gray775: '#495057',
    gray800: '#424242',
    gray900: '#212121',
    
    // fonts
    fontFamilySerif: '"Sentinel A", "Sentinel B", serif',
    fontFamilySansSerif: "National2",

    gridBreakpoints: {
        xs: '0',
        sm: '576px',
        md: '768px',
        lg: '992px',
        xl: '1200px',
        xxl: '1440px',
    }
}

export default theme;